import type { InstructionPromptKind } from '@onefootprint/request-types/dashboard';
import { createContext, useContext } from 'react';

/**
 * Which graph node the surrounding prompt editor belongs to. Blocks that judge the graph from a
 * task's position (the needs block: "is this key produced before me?") read it; outside a provider
 * they render without a verdict rather than guessing one. Tiptap's ReactNodeViewRenderer portals
 * node views under the editor's own React tree, so this context reaches them.
 */
const TaskBlockContext = createContext<{
  nodeId: string;
  promptKind?: InstructionPromptKind;
  promptKey?: string;
} | null>(null);
export const TaskBlockProvider = TaskBlockContext.Provider;
export const useTaskBlockContext = () => {
  return useContext(TaskBlockContext);
};